import { Helmet } from 'react-helmet';
import './Video.css';
import YouTubeVideo from './Youtube'
import { useEffect } from 'react';
// Import thumbnail images
import Galaxy from './images/GalaxyVid (Medium).png';
import Fairytale from './images/FairytaleVid (Medium).png';
import LoveWeaves from './images/LoveWeavesVid (Medium).png';
import Lullaby from './images/LullabyVid (Medium).png';
import LittleThings from './images/LittleThingsVid (Medium).png';

function Videos() {

  useEffect(() => {
    // Scroll to the top of the page when the component mounts
    window.scrollTo(0, 0);
  }, []);

  const videolist = [
    {
      name: 'Love that Weaves Warriors',
      videoId: 'ZhuHls3laEs?si=d9sredaDtkchz7HX',
    },
    {
      name: 'Fairytale',
      videoId: 't3YFeWK18_g?si=Nm883jnsF08besBs',
    },
    {
      name: 'Galaxy',
      videoId: 'HrHXEhnaORU?si=wYOG4gAZvdMT0ZgF',
    },
    {
      name: 'Lullaby',
      videoId: 'OiRTxxXC9W8?si=MWh60JGhgJ3Hx2pd',
    },
    {
      name: 'All the Little Things',
      videoId: '2Z8lHDzHc28?si=g2_u6UWbmPFDTzsQ',
    },
  ];

  return (
    <div>
      <Helmet>
        <title>Video Page</title>
        <meta name="description" content="View Aethel's music here via her YouTube videos." />

        {/* Page-Specific Open Graph Tags */}
        <meta property="og:title" content="Video Page - Aethel Music" />
        <meta property="og:description" content="View Aethel's music here via her YouTube videos." />
        <meta property="og:image" content="%PUBLIC_URL%/images/BiopicMedium.png" />
        <meta property="og:url" content="https://aethel.vercel.app/video" />

        {/* Page-Specific Twitter Card Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Video Page - Aethel Music" />
        <meta name="twitter:description" content="View Aethel's music here via her YouTube videos." />
        <meta name="twitter:image" content="%PUBLIC_URL%/images/BiopicMedium.png" />
      </Helmet>
      <div className='video-heading'>
        <h1>Æthel Videos</h1>
      </div>
      <div className='videos'>
        {videolist.map((playlist, index) => (
          <YouTubeVideo
            key={index}
            videoId={playlist.videoId}
            thumbnail={getThumbnailByVideoId(playlist.videoId)}
          />
        ))}
      </div>
    </div>
  );
}

// Function to get the correct thumbnail image based on video ID
function getThumbnailByVideoId(videoId) {
  switch (videoId) {
    case 'ZhuHls3laEs?si=d9sredaDtkchz7HX':
      return LoveWeaves;
    case 't3YFeWK18_g?si=Nm883jnsF08besBs':
      return Fairytale;
    case 'HrHXEhnaORU?si=wYOG4gAZvdMT0ZgF':
      return Galaxy;
    case 'OiRTxxXC9W8?si=MWh60JGhgJ3Hx2pd':
      return Lullaby;
    case '2Z8lHDzHc28?si=g2_u6UWbmPFDTzsQ':
      return LittleThings;
    default:
      return null;
  }
}

export default Videos;



